import Vue from "vue";
import VueRouter from "vue-router";
import { routerMode } from "@/config/settings";
import Layout from "@/components/layout/index";

Vue.use(VueRouter);

export const anonymousRoutes = [
  {
    path: "/",
    component: Layout,
    redirect: "index",
    children: [
      {
        path: "index",
        name: "Index",
        // component: () => import("@/views/index/index"),
        component: () => import("@/views/recruit/yuanDesc/index"),
        meta: {
          title: "首页",
          icon: "home",
          affix: true,
        },
      },
    ],
  },
  {
    path: "/yuanDesc",
    component: Layout,
    redirect: "index",
    children: [
      {
        path: "index",
        name: "YuanDesc",
        // component: () => import("@/views/recruit/yuanDesc/index"),
        component: () => import("@/views/index/index"),
        meta: {
          title: "院所概览",
          icon: "building",
        },
      },
      {
        path: "1introduce",
        name: "1introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/1introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "2introduce",
        name: "2introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/2introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "3introduce",
        name: "3introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/3introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "4introduce",
        name: "4introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/4introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "5introduce",
        name: "5introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/5introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "6introduce",
        name: "6introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/6introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "7introduce",
        name: "7introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/7introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "8introduce",
        name: "8introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/8introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "9introduce",
        name: "9introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/9introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "10introduce",
        name: "10introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/10introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "11introduce",
        name: "11introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/11introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "12introduce",
        name: "12introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/12introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "13introduce",
        name: "13introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/13introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "14introduce",
        name: "14introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/14introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "15introduce",
        name: "15introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/15introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "17introduce",
        name: "17introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/17introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "18introduce",
        name: "18introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/18introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
    ],
  },
  {
    path: "/recruitInfo",
    component: Layout,
    redirect: "index",
    children: [
      {
        path: "index",
        name: "RecruitInfo",
        component: () => import("@/views/recruit/recruitInfo/index"),
        meta: {
          title: "招聘信息",
          icon: "clipboard",
        },
      },
    ],
  },
  {
    path: "/positionView",
    component: Layout,
    redirect: "index",
    hidden: true,
    children: [
      {
        path: "index",
        name: "PositionView",
        component: () => import("@/views/recruit/hr/positionView"),
        meta: {
          title: "职位信息",
          icon: "home",
        },
      },
    ],
  },
];

export const studentRoutes = [
  {
    path: "/",
    component: Layout,
    redirect: "index",
    children: [
      {
        path: "index",
        name: "Index",
        // component: () => import("@/views/index/index"),
        component: () => import("@/views/recruit/yuanDesc/index"),
        meta: {
          title: "首页",
          icon: "home",
          affix: true,
        },
      },
    ],
  },
  {
    path: "/yuanDesc",
    component: Layout,
    redirect: "index",
    children: [
      {
        path: "index",
        name: "YuanDesc",
        // component: () => import("@/views/recruit/yuanDesc/index"),
        component: () => import("@/views/index/index"),
        meta: {
          title: "院所概览",
          icon: "building",
        },
      },
      {
        path: "1introduce",
        name: "1introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/1introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "2introduce",
        name: "2introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/2introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "3introduce",
        name: "3introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/3introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "4introduce",
        name: "4introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/4introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "5introduce",
        name: "5introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/5introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "6introduce",
        name: "6introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/6introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "7introduce",
        name: "7introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/7introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "8introduce",
        name: "8introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/8introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "9introduce",
        name: "9introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/9introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "10introduce",
        name: "10introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/10introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "11introduce",
        name: "11introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/11introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "12introduce",
        name: "12introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/12introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "13introduce",
        name: "13introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/13introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "14introduce",
        name: "14introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/14introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "15introduce",
        name: "15introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/15introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "17introduce",
        name: "17introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/17introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "18introduce",
        name: "18introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/18introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
    ],
  },
  {
    path: "/recruitInfo",
    component: Layout,
    redirect: "index",
    children: [
      {
        path: "index",
        name: "RecruitInfo",
        component: () => import("@/views/recruit/recruitInfo/index"),
        meta: {
          title: "招聘信息",
          icon: "clipboard",
        },
      },
    ],
  },
  // {
  //   path: "/applicant",
  //   component: Layout,
  //   redirect: "personalResume1",
  //   children: [
  //     {
  //       path: "personalResume1",
  //       name: "PersonalResume1",
  //       component: () => import("@/views/recruit/applicant/personalResume"),
  //       meta: {
  //         title: "我的简历旧",
  //         icon: "id-card",
  //       },
  //     },
  //   ],
  // },
  {
    path: "/applicant",
    component: Layout,
    redirect: "personalResume",
    children: [
      {
        path: "personalResume",
        name: "PersonalResume",
        component: () => import("@/views/recruit/applicant/personalResumeNew"),
        meta: {
          title: "我的简历",
          icon: "id-card",
        },
      },
    ],
  },
  // {
  //   path: "/applicant",
  //   component: Layout,
  //   redirect: "personalResume",
  //   children: [
  //     {
  //       path: "personalResume",
  //       name: "PersonalResume",
  //       component: () => import("@/views/recruit/applicant/personalResume"),
  //       meta: {
  //         title: "我的简历",
  //         icon: "id-card",
  //       },
  //     },
  //   ],
  // },
  {
    path: "/positionList",
    component: Layout,
    redirect: "index",
    children: [
      {
        path: "index",
        name: "PositionList",
        component: () => import("@/views/recruit/applicant/positionList"),
        meta: {
          title: "我的投递",
          icon: "paper-plane",
        },
      },
    ],
  },
  {
    path: "/positionView",
    component: Layout,
    redirect: "index",
    hidden: true,
    children: [
      {
        path: "index",
        name: "PositionView",
        component: () => import("@/views/recruit/hr/positionView"),
        meta: {
          title: "职位信息",
          icon: "home",
        },
      },
    ],
  },
];

export const hrRoutes = [
  {
    path: "/",
    component: Layout,
    redirect: "index",
    children: [
      {
        path: "index",
        name: "Index",
        component: () => import("@/views/recruit/hr/index"),
        meta: {
          title: "首页",
          icon: "home",
          affix: true,
        },
      },
    ],
  },
  /*{
    path: "/yuanDesc",
    component: Layout,
    redirect: "index",
    children: [
      {
        path: "index",
        name: "YuanDesc",
        component: () => import("@/views/recruit/yuanDesc/index"),
        meta: {
          title: "院情介绍",
          icon: "building",
        },
      },
      {
        path: "1introduce",
        name: "1introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/1introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "2introduce",
        name: "2introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/2introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "3introduce",
        name: "3introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/3introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "4introduce",
        name: "4introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/4introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "5introduce",
        name: "5introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/5introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "6introduce",
        name: "6introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/6introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "7introduce",
        name: "7introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/7introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "8introduce",
        name: "8introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/8introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "9introduce",
        name: "9introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/9introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "10introduce",
        name: "10introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/10introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "11introduce",
        name: "11introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/11introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "12introduce",
        name: "12introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/12introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "13introduce",
        name: "13introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/13introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "14introduce",
        name: "14introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/14introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "17introduce",
        name: "17introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/17introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "18introduce",
        name: "18introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/18introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
    ],
  },
  {
    path: "/recruitInfo",
    component: Layout,
    redirect: "index",
    children: [
      {
        path: "index",
        name: "RecruitInfo",
        component: () => import("@/views/recruit/recruitInfo/index"),
        meta: {
          title: "招聘信息",
          icon: "clipboard",
        },
      },
    ],
  },*/
  {
    path: "/deptDesc",
    component: Layout,
    redirect: "index",
    children: [
      {
        path: "index",
        name: "DeptDesc",
        component: () => import("@/views/recruit/hr/deptDesc"),
        meta: {
          title: "单位介绍",
          icon: "newspaper",
        },
      },
    ],
  },
  {
    path: "/positionManagement",
    component: Layout,
    redirect: "index",
    children: [
      {
        path: "index",
        name: "PositionManagement",
        component: () => import("@/views/recruit/hr/positionManagement"),
        meta: {
          title: "职位管理",
          icon: "landmark",
        },
      },
    ],
  },
  {
    path: "/resumeManagement",
    component: Layout,
    redirect: "index",
    children: [
      {
        path: "index",
        name: "ResumeManagement",
        component: () => import("@/views/recruit/hr/resumeManagement"),
        meta: {
          title: "简历管理",
          icon: "id-card",
        },
      },
    ],
  },
  /*{
    path: "/positionEdit",
    component: Layout,
    redirect: "index",
    hidden: true,
    children: [
      {
        path: "index",
        name: "PositionEdit",
        component: () => import("@/views/recruit/hr/positionEdit"),
        meta: {
          title: "职位发布",
          icon: "home",
        },
      },
    ],
  },*/
  {
    path: "/positionView",
    component: Layout,
    redirect: "index",
    hidden: true,
    children: [
      {
        path: "index",
        name: "PositionView",
        component: () => import("@/views/recruit/hr/positionView"),
        meta: {
          title: "职位信息",
          icon: "home",
        },
      },
    ],
  },
  {
    path: "/personalResumeView",
    component: Layout,
    redirect: "index",
    hidden: true,
    children: [
      {
        path: "index",
        name: "PersonalResumeView",
        component: () => import("@/views/recruit/applicant/personalResumeView"),
        meta: {
          title: "简历查看",
          icon: "id-card",
        },
      },
    ],
  },
  {
    path: "/otherResumeView",
    component: Layout,
    redirect: "index",
    hidden: true,
    children: [
      {
        path: "index",
        name: "OtherResumeView",
        component: () => import("@/views/recruit/applicant/otherResumeView"),
        meta: {
          title: "其他投递信息",
          icon: "id-card",
        },
      },
    ],
  },
  {
    path: "/modifyPassword",
    component: Layout,
    redirect: "index",
    hidden: true,
    children: [
      {
        path: "index",
        name: "ModifyPassword",
        component: () => import("@/views/recruit/applicant/modifyPassword"),
        meta: {
          title: "修改密码",
          icon: "edit",
        },
      },
    ],
  },
];

export const hrAdminRoutes = [
  {
    path: "/",
    component: Layout,
    redirect: "index",
    children: [
      {
        path: "index",
        name: "Index",
        component: () => import("@/views/recruit/hr/index"),
        meta: {
          title: "首页",
          icon: "home",
          affix: true,
        },
      },
    ],
  },
  /* {
    path: "/yuanDesc",
    component: Layout,
    redirect: "index",
    children: [
      {
        path: "index",
        name: "YuanDesc",
        component: () => import("@/views/recruit/yuanDesc/index"),
        meta: {
          title: "院情介绍",
          icon: "building",
        },
      },
      {
        path: "1introduce",
        name: "1introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/1introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "2introduce",
        name: "2introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/2introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "3introduce",
        name: "3introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/3introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "4introduce",
        name: "4introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/4introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "5introduce",
        name: "5introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/5introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "6introduce",
        name: "6introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/6introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "7introduce",
        name: "7introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/7introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "8introduce",
        name: "8introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/8introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "9introduce",
        name: "9introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/9introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "10introduce",
        name: "10introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/10introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "11introduce",
        name: "11introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/11introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "12introduce",
        name: "12introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/12introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "13introduce",
        name: "13introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/13introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "14introduce",
        name: "14introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/14introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "17introduce",
        name: "17introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/17introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "18introduce",
        name: "18introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/18introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
    ],
  },
  {
    path: "/recruitInfo",
    component: Layout,
    redirect: "index",
    children: [
      {
        path: "index",
        name: "RecruitInfo",
        component: () => import("@/views/recruit/recruitInfo/index"),
        meta: {
          title: "招聘信息",
          icon: "clipboard",
        },
      },
    ],
  },*/
  {
    path: "/deptDesc",
    component: Layout,
    redirect: "index",
    children: [
      {
        path: "index",
        name: "DeptDesc",
        component: () => import("@/views/recruit/hr/deptDesc"),
        meta: {
          title: "单位介绍",
          icon: "newspaper",
        },
      },
    ],
  },
  {
    path: "/positionManagement",
    component: Layout,
    redirect: "index",
    children: [
      {
        path: "index",
        name: "PositionManagement",
        component: () => import("@/views/recruit/hr/positionManagement"),
        meta: {
          title: "职位管理",
          icon: "landmark",
        },
      },
    ],
  },
  {
    path: "/resumeManagement",
    component: Layout,
    redirect: "index",
    children: [
      {
        path: "index",
        name: "ResumeManagement",
        component: () => import("@/views/recruit/hr/resumeManagement"),
        meta: {
          title: "简历管理",
          icon: "id-card",
        },
      },
    ],
  },
  {
    path: "/positionEdit",
    component: Layout,
    redirect: "index",
    hidden: true,
    children: [
      {
        path: "index",
        name: "PositionEdit",
        component: () => import("@/views/recruit/hr/positionEdit"),
        meta: {
          title: "职位发布",
          icon: "home",
        },
      },
    ],
  },
  {
    path: "/positionView",
    component: Layout,
    redirect: "index",
    hidden: true,
    children: [
      {
        path: "index",
        name: "PositionView",
        component: () => import("@/views/recruit/hr/positionView"),
        meta: {
          title: "职位信息",
          icon: "home",
        },
      },
    ],
  },
  {
    path: "/personalResumeView",
    component: Layout,
    redirect: "index",
    hidden: true,
    children: [
      {
        path: "index",
        name: "PersonalResumeView",
        component: () => import("@/views/recruit/applicant/personalResumeView"),
        meta: {
          title: "简历查看",
          icon: "id-card",
        },
      },
    ],
  },
  {
    path: "/otherResumeView",
    component: Layout,
    redirect: "index",
    hidden: true,
    children: [
      {
        path: "index",
        name: "OtherResumeView",
        component: () => import("@/views/recruit/applicant/otherResumeView"),
        meta: {
          title: "其他投递信息",
          icon: "id-card",
        },
      },
    ],
  },
  {
    path: "/modifyPassword",
    component: Layout,
    redirect: "index",
    hidden: true,
    children: [
      {
        path: "index",
        name: "ModifyPassword",
        component: () => import("@/views/recruit/applicant/modifyPassword"),
        meta: {
          title: "修改密码",
          icon: "edit",
        },
      },
    ],
  },
];

export const adminRoutes = [
  {
    path: "/",
    component: Layout,
    redirect: "index",
    children: [
      {
        path: "index",
        name: "Index",
        component: () => import("@/views/recruit/hr/index"),
        meta: {
          title: "首页",
          icon: "home",
          affix: true,
        },
      },
    ],
  },
  /*{
    path: "/yuanDesc",
    component: Layout,
    redirect: "index",
    children: [
      {
        path: "index",
        name: "YuanDesc",
        component: () => import("@/views/recruit/yuanDesc/index"),
        meta: {
          title: "院情介绍",
          icon: "building",
        },
      },
      {
        path: "1introduce",
        name: "1introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/1introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "2introduce",
        name: "2introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/2introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "3introduce",
        name: "3introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/3introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "4introduce",
        name: "4introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/4introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "5introduce",
        name: "5introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/5introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "6introduce",
        name: "6introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/6introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "7introduce",
        name: "7introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/7introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "8introduce",
        name: "8introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/8introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "9introduce",
        name: "9introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/9introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "10introduce",
        name: "10introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/10introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "11introduce",
        name: "11introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/11introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "12introduce",
        name: "12introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/12introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "13introduce",
        name: "13introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/13introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "14introduce",
        name: "14introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/14introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "17introduce",
        name: "17introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/17introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
      {
        path: "18introduce",
        name: "18introduce",
        component: () =>
          import("@/views/recruit/yuanDesc/introduce/18introduce"),
        hidden: true,
        meta: {
          title: "单位介绍",
          icon: "home",
        },
      },
    ],
  },
  {
    path: "/recruitInfo",
    component: Layout,
    redirect: "index",
    children: [
      {
        path: "index",
        name: "RecruitInfo",
        component: () => import("@/views/recruit/recruitInfo/index"),
        meta: {
          title: "招聘信息",
          icon: "clipboard",
        },
      },
    ],
  },*/
  {
    path: "/deptDesc",
    component: Layout,
    redirect: "index",
    children: [
      {
        path: "index",
        name: "DeptDesc",
        component: () => import("@/views/recruit/hr/deptDesc"),
        meta: {
          title: "单位介绍",
          icon: "newspaper",
        },
      },
    ],
  },
  {
    path: "/positionManagement",
    component: Layout,
    redirect: "index",
    children: [
      {
        path: "index",
        name: "PositionManagement",
        component: () => import("@/views/recruit/hr/positionManagement"),
        meta: {
          title: "职位管理",
          icon: "landmark",
        },
      },
    ],
  },
  {
    path: "/otherResumeView",
    component: Layout,
    redirect: "index",
    hidden: true,
    children: [
      {
        path: "index",
        name: "OtherResumeView",
        component: () => import("@/views/recruit/applicant/otherResumeView"),
        meta: {
          title: "其他投递信息",
          icon: "id-card",
        },
      },
    ],
  },
  {
    path: "/resumeManagement",
    component: Layout,
    redirect: "index",
    children: [
      {
        path: "index",
        name: "ResumeManagement",
        component: () => import("@/views/recruit/hr/resumeManagement"),
        meta: {
          title: "简历管理",
          icon: "id-card",
        },
      },
    ],
  },
  {
    path: "/admin",
    component: Layout,
    meta: {
      title: "系统管理",
      icon: "hammer",
    },
    children: [
      {
        path: "org",
        name: "OrgManagement",
        component: () => import("@/views/recruit/framework/org/index"),
        meta: {
          title: "机构管理",
          icon: "house-user",
        },
      },
      {
        path: "auth",
        name: "AuthManagement",
        component: () => import("@/views/recruit/framework/auth/index"),
        meta: {
          title: "授权管理",
          icon: "user-lock",
        },
      },
      {
        path: "basicData",
        name: "BasicDataManagement",
        component: () => import("@/views/recruit/framework/basicData/index"),
        meta: {
          title: "数据字典",
          icon: "book",
        },
      },
      // {
      //   path: "user",
      //   name: "UserManagement",
      //   component: () => import("@/views/recruit/framework/user/index"),
      //   meta: {
      //     title: "用户管理",
      //     icon: "user",
      //   },
      // },
    ],
  },
  {
    path: "/positionEdit",
    component: Layout,
    redirect: "index",
    hidden: true,
    children: [
      {
        path: "index",
        name: "PositionEdit",
        component: () => import("@/views/recruit/hr/positionEdit"),
        meta: {
          title: "职位发布",
          icon: "home",
        },
      },
    ],
  },
  {
    path: "/positionView",
    component: Layout,
    redirect: "index",
    hidden: true,
    children: [
      {
        path: "index",
        name: "PositionView",
        component: () => import("@/views/recruit/hr/positionView"),
        meta: {
          title: "职位信息",
          icon: "home",
        },
      },
    ],
  },
  {
    path: "/personalResumeView",
    component: Layout,
    redirect: "index",
    hidden: true,
    children: [
      {
        path: "index",
        name: "PersonalResumeView",
        component: () => import("@/views/recruit/applicant/personalResumeView"),
        meta: {
          title: "简历查看",
          icon: "id-card",
        },
      },
    ],
  },
  {
    path: "/otherResumeView",
    component: Layout,
    redirect: "index",
    hidden: true,
    children: [
      {
        path: "index",
        name: "OtherResumeView",
        component: () => import("@/views/recruit/applicant/otherResumeView"),
        meta: {
          title: "其他投递信息",
          icon: "id-card",
        },
      },
    ],
  },
  {
    path: "/modifyPassword",
    component: Layout,
    redirect: "index",
    hidden: true,
    children: [
      {
        path: "index",
        name: "ModifyPassword",
        component: () => import("@/views/recruit/applicant/modifyPassword"),
        meta: {
          title: "修改密码",
          icon: "edit",
        },
      },
    ],
  },
];

export const constantRoutes = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
  },
  {
    path: "/register",
    component: () => import("@/views/register/index"),
    hidden: true,
  },
  {
    path: "/adminLogin",
    component: () => import("@/views/login/adminLogin"),
    hidden: true,
  },
  {
    path: "/forgetPass",
    component: () => import("@/views/login/forgetPassword"),
    hidden: true,
  },
  // {
  //   path: "/forgetPass",
  //   component: () => import("@/views/login/getPhoneCode"),
  //   hidden: true,
  // },
  // {
  //   path: "/phoneLoadPassword",
  //   component: () => import("@/views/login/phoneLoadPassword"),
  //   hidden: true,
  // },
  {
    path: "/401",
    name: "401",
    component: () => import("@/views/401"),
    hidden: true,
  },
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/404"),
    hidden: true,
  },
];

export const errRoutes = [
  {
    path: "*",
    redirect: "/404",
    hidden: true,
  },
];

const router = new VueRouter({
  mode: routerMode,
  scrollBehavior: () => ({
    y: 0,
  }),
  routes: constantRoutes.concat(anonymousRoutes),
});

export function resetRouter() {
  router.matcher = new VueRouter({
    mode: routerMode,
    scrollBehavior: () => ({
      y: 0,
    }),
    routes: constantRoutes,
  }).matcher;
}

export function resetAnonymousRouter() {
  router.matcher = new VueRouter({
    mode: routerMode,
    scrollBehavior: () => ({
      y: 0,
    }),
    routes: constantRoutes.concat(anonymousRoutes),
  }).matcher;
}

export default router;
